export const getResourceProps = (propsResource = {}, resourceName = '') => {
  const storage = localStorage.getItem('currentResource')
  return storage ? JSON.parse(storage) : propsResource[resourceName]
}

export const setResourceProps = (propsResource, resourceName) => {
  const resource = propsResource[resourceName] ? JSON.stringify(propsResource[resourceName]) : null
  localStorage.setItem('currentResource', resource)
  return propsResource[resourceName]
}
